import { LocationEnum } from '@/__generated__/graphql';
import { BuildingIcon } from '@/component/Icons/BuildingIcon';
import { CompassIcon } from '@/component/Icons/CompassIcon';
import { LocationIcon } from '@/component/Icons/LocationIcon';

export const IconsPalette = {
  [LocationEnum.Street]: <BuildingIcon />,
  [LocationEnum.Place]: <LocationIcon />,
  [LocationEnum.Locality]: <CompassIcon />,
};

export const i18nMap = {
  [LocationEnum.Street]: 'form.autocomplete.street',
  [LocationEnum.Place]: 'form.autocomplete.place',
  [LocationEnum.Locality]: 'form.autocomplete.locality',
};
